import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="relative overflow-hidden rounded-[20px] bg-mist px-6 py-14 text-night-flight after:absolute after:bottom-0 after:left-0 after:h-3 after:w-2/5 after:bg-terracotta md:px-10 md:py-20 lg:px-14 lg:py-24">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="max-w-[15ch] text-5xl md:text-7xl lg:text-8xl"
          tone="light"
        />
      </div>
    </StratosSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
